// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type QuickViewState = {
    product: ProductModel;
    productInfo: ProductInfo;
    isModalOpen: boolean;
    isLoading: { [id: string]: boolean };
    selectedImage?: number;
};

const initialQuickViewState: QuickViewState = {
    isLoading: {},
    isModalOpen: false,
    product: {} as ProductModel,
    productInfo: {} as ProductInfo,
    selectedImage: 0,
};

const quickView = createTypedReducerWithImmer(initialQuickViewState, {
    "QuickView/BeginSetProduct": (draft: Draft<QuickViewState>, actions: { id: string }) => {
        draft.isLoading[actions.id] = true;
    },
    "QuickView/CompleteSetProduct": (draft: Draft<QuickViewState>) => {
        draft.isLoading = {};
    },
    "QuickView/CloseModal": (draft: Draft<QuickViewState>) => {
        draft.productInfo = initialQuickViewState.productInfo;
        draft.isLoading = initialQuickViewState.isLoading;
        draft.isModalOpen = initialQuickViewState.isModalOpen;
        draft.product = initialQuickViewState.product;
        draft.selectedImage = initialQuickViewState.selectedImage;
    },
    "QuickView/SetProduct": (draft: Draft<QuickViewState>, action: { product: ProductModel }) => {
        draft.product = action.product;
    },
    "QuickView/SetProductInfo": (draft: Draft<QuickViewState>, action: { productInfo: ProductInfo }) => {
        draft.productInfo = action.productInfo;
        draft.isModalOpen = true;
    },
    "QuickView/UpdateQuantity": (draft: Draft<QuickViewState>, action: { qtyOrder: number }) => {
        draft.productInfo.qtyOrdered = action.qtyOrder;
    },
    "QuickView/UpdateUnitOfMeasure": (draft: Draft<QuickViewState>, action: { uom: string }) => {
        draft.productInfo.unitOfMeasure = action.uom;
    },
    "QuickView/UpdateSelectedImageIndex": (draft: Draft<QuickViewState>, action: { index: number }) => {
        draft.selectedImage = action.index;
    },
});

(reducers as any).quickView = quickView;

type quickViewReducers = {
    systemList: typeof quickView;
};

export type quickViewActions = Parameters<quickViewReducers[keyof quickViewReducers]>[1] | AnyAction;
